import { render } from "./EmojiPickerSheet.vue?vue&type=template&id=c4899266&scoped=true"
import script from "./EmojiPickerSheet.vue?vue&type=script&lang=js"
export * from "./EmojiPickerSheet.vue?vue&type=script&lang=js"

import "./EmojiPickerSheet.vue?vue&type=style&index=0&id=c4899266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4899266"]])

export default __exports__